<template>
  <v-container class="visit-filters">
    <v-row
      align="center"
      justify="end"
    >
      <v-col
        cols="12"
      >
        <span
          class="m-2 "
          style="text-align='right'"
        >
          {{ `${selectedTypes.length} ${$t('forms.labels.analysesSelected')}` }}
        </span>
      </v-col>

      <v-btn
        color="secondary"
        class="siteTree-btn m-2"
        :disabled="isCompletedOrLocked"
        @click="onClickToggleAll()"
      >
        {{ allSelected ? $t('forms.btn.unselectAll') : $t('forms.btn.selectAll') }}
      </v-btn>
    </v-row>

    <v-row
      align="stretch"
      justify="space-between"
      class="selectAnalysis"
    >
      <div
        v-for="(type, index) in displayedTypes"
        :key="type.ref"
        class="m-1"
        style="flex: 1;"
      >
        <v-btn
          :color="type.selected ? 'secondary' : 'accent'"
          width="100%"
          class="siteTree-btn selectAnalysis__blocTitle"
          :disabled="isCompletedOrLocked"
          @click="onClickToggle(index)"
        >
          <span>
            {{ type.name }}
          </span>
          <v-icon
            :class="type.selected ? 'visible' : 'hidden'"
          >
            mdi-check
          </v-icon>
        </v-btn>
      </div>
    </v-row>

    <v-row
      align="center"
      justify="center"
    >
      <v-btn
        icon
        color="secondary"
        :disabled="mutableTypes.length <= minDisplayed || isCompletedOrLocked"
        @click="showAll = !showAll"
      >
        <v-icon>
          {{ iconArrow }}
        </v-icon>
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import completionStatus from '@/constants/workOrderStatusChoices';

export default {
    props: {
        analysisTypes: {
            type: Array,
            default: () => [],
        },
        minDisplayed: {
            type: Number,
            default: 12,
        },
    },
    data() {
        return {
            mutableTypes: [],
            showAll: true,
        };
    },
    computed: {
        ...mapGetters([
            'userLang',
            'workOrder',
        ]),
        displayedTypes() {
            const list = this.showAll
                ? this.mutableTypes
                : this.mutableTypes.slice(0, this.minDisplayed);

            return list.map(({ name, ...props }) => ({
                ...props,
                name: name[this.userLang],
            }));
        },
        iconArrow() {
            return this.showAll ? 'mdi-chevron-up' : 'mdi-chevron-down';
        },
        selectedTypes() {
            return this.mutableTypes.filter(type => type.selected);
        },
        allSelected() {
            return this.mutableTypes.every(type => type.selected === true);
        },
        isCompletedOrLocked() {
            return this.workOrder?.completionStatus === completionStatus.COMPLETED || !!this.workOrder?.lockData?.isLocked;
        },
    },
    watch: {
        selectedTypes() {
            this.$emit('filter', this.selectedTypes);
        },
    },
    created() {
        this.selectAll(true);
    },
    methods: {
        onClickToggle(index) {
            const { selected } = this.mutableTypes[index];
            this.mutableTypes[index].selected = !selected;
        },
        onClickToggleAll() {
            this.selectAll(!this.allSelected);
        },
        selectAll(selected) {
            this.mutableTypes = this.analysisTypes.map(type => ({
                ...type,
                selected,
            }));
        },
    },
};
</script>

<style lang="scss" scoped>

@media screen and (max-width: 600px) {
  .selectAnalysis {
    min-width: 280px !important;
    max-width: 100% !important;
    &__blocTitle {
      width: 240px !important;
    }
  }
}
</style>
